<template>
  <!-- 历史数据 -->
  <a-row :gutter="12">
    <a-col :md="24" :sm="24">
      <a-col :md="6" :sm="24">
        <a-card :bordered="false" style="height: 763px">
          <div slot="title" class="cardTitle">汝城水务</div>
          <div class="box">
            <a-tree
              v-if="zoneTreeData.length"
              checkable
              v-model="checkedKeys"
              :tree-data="zoneTreeData"
              :defaultExpandAll="true"
              :auto-expand-parent="true"
              style="width: 100%"
              :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
              @check="onCheck"
            ></a-tree>
          </div>
        </a-card>
      </a-col>
      <a-col :md="18" :sm="24">
        <a-card :bordered="false">
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="6" :sm="12">
                  <a-form-item label="用户编号">
                    <a-input v-model="query.appearanceNo" placeholder="请输入用户编号" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="12">
                  <a-form-item label="选择时间">
                    <a-date-picker
                      mode="month"
                      format="YYYY-MM"
                      v-model="query.monthTime"
                      :open="open"
                      @change="onChange"
                      @openChange="handleOpenChange"
                      @panelChange="handlePanelChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="12">
                  <a-form-item label="用户名称">
                    <a-input v-model="query.username" placeholder="请输入用户名称" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="queryList">查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
                    <a-button
                      type="primary"
                      style="margin-left: 8px"
                      :loading="exportLoading"
                      @click="exportHandle()"
                      v-action:export
                      >导出</a-button
                    >
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <a-table
            rowKey="id"
            bordered
            :data-source="list"
            :columns="columns"
            :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
            :loading="dataListLoading"
            :pagination="pagination"
            @change="pageChange"
          ></a-table>
        </a-card>
      </a-col>
    </a-col>
  </a-row>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import { getPipeLineMaterialOptions, getPipeDiameterSizeOptions } from '@/api/manage'
const columns = [
  {
    title: '用户编号',
    dataIndex: 'appearanceNo',
  },
  {
    title: '表身号',
    dataIndex: 'meterModel',
  },
  {
    title: '用户名称',
    dataIndex: 'userNikeName',
    ellipsis: true,
  },
  {
    title: '用户地址',
    dataIndex: 'address',
    ellipsis: true,
  },
  {
    title: '当前月',
    dataIndex: 'theCurrentMonth',
  },
  {
    title: '两个月前',
    dataIndex: 'twoMonthsAgo',
  },
  {
    title: '三个月前',
    dataIndex: 'threeMonthsAgo',
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'WaterStatement',
  data() {
    return {
      open: false,
      currentId: '',
      selectedKeys: '',
      queryUrl: '/pipe-network/yc_user_remote_water_meters/water/report',
      exportDataUrl: 'pipe-network/yc_user_remote_water_meters/export/report',
      exportFileName: '水量报表.xlsx',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      zoneTreeData: [], // 片区选项
      pushTime: [],
      checkedKeys: [],
      query: {
        zoneIds: '',
        username: '',
        tenantId: this.$store.state.user.info.tenantId,
        monthTime: '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
    }
  },
  filters: {
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  created() {
    this.getAllTenant()
    this.getZoneData()
  },
  methods: {
    handleCancel() {},
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    // 重置
    resetList() {
      this.pushTime = []
      this.query = {}
      this.pagination.current = 1
      this.queryList()
      this.checkedKeys = []
      console.log(this.pushTime)
    },
    onCheck(checkedKeys, info) {
      console.log(this.checkedKeys)
      this.query.zoneIds = checkedKeys.join(',')
    },
    onChange(date, dateString) {
      console.log(date, dateString)
    },
    handleOpenChange() {
      this.open = true
    },
    handlePanelChange(value) {
      console.log(value)
      this.query.monthTime = value.format('YYYY-MM')
      this.open = false
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.cardTitle {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.71px;
  font-weight: 600;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
.box {
  height: 650px;
  width: 100%;
  overflow: auto;
  // 滚动条整体部分
  &::-webkit-scrollbar {
    width: 0px; //对垂直方向滚动条
    height: 0px; //对水平方向滚动条
  }
  //滚动的滑块
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #ccc//滚动条的颜色;
  }
  //内层滚动槽
  &::-webkit-scrollbar-track-piece {
    background-color: #ccc;
  }
}
</style>
